import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { Container, Grid, LinearProgress, makeStyles, Typography, FormControlLabel, Button } from '@material-ui/core';
import { MyMess, history } from '../../App';
import { Switch } from 'formik-material-ui';
import { FormikPersistStore } from '../../component/FormikPersistStore';
import { GlobalSnackBarUtil } from '../../component/GlobalSnackBar';
import { useRouteMatch, useParams } from 'react-router-dom';
import { checkRequiredHandler } from '../../component/FormUtil';
import { asyncSaveMerchantEdit, clearMerchantEdit, readMerchantEdit, updateMerchantEdit } from '../../redux/ducks/merchantEditDuck';
import { isEmail } from '../../utils/Utils';


const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
  }));

const basicInfoForm = (editorState) => {

    return(
    <React.Fragment>
        <Grid item xs={12}>
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
                {MyMess.merchant.basicInfo}
            </Typography>
        </Grid>

        <Grid item xs={12}>         
            <Field name="email">{(props) => 
                <TextField                                    
                required
                disabled={editorState.mode !== 'create'}                                    
                inputProps={{ style: { textTransform: "lowercase" } }}
                label={MyMess.merchant.email}
                fullWidth {...props}/>}   
            </Field>
        </Grid>
        {editorState.mode === 'create' && 
                <Grid item xs={12}>         
                <Field                                
                name="password"
                type="password">
                {(props) => 
                    <TextField                                    
                    required
                    type="password"                    
                    label={MyMess.signUp.password}
                    fullWidth {...props}/>}  
                </Field>
            </Grid>  }   
            {editorState.mode === 'create' && 
            <Grid item xs={12}>
            <Field                                
                name="repw"      
                type="password"                                                          
                >
                    {(props) => 
                    <TextField                                    
                    required
                    type="password"
                    disabled={editorState.mode !== 'create'}                                    
                    label={MyMess.signUp.confirmPw}
                    fullWidth {...props}/>}  
                </Field>
            </Grid>
        }
        <Grid item xs={12}>         
            <Field                                
            name="progCode">
                {(props) => 
                <TextField                                    
                required
                //disabled={editorState.mode !== 'create'}                                    
                label={MyMess.merchant.progCode}
                fullWidth {...props}/>}  
            </Field>
        </Grid>
        <Grid item xs={12}>                
            <Field            
            name="firstName"                                
                    
            >{(props) => 
                <TextField  
                label={MyMess.merchant.firstName}
                fullWidth {...props}/>}  
                </Field>                
        </Grid>
        <Grid item xs={12}>                
            <Field            
            name="lastName"                                
            render={(props) => 
                <TextField    
                label={MyMess.merchant.lastName}
                fullWidth {...props}/>}          
            />                
        </Grid>
    </React.Fragment>  )
}

const secondAuthForm = (editorState) => {
    return(
        <React.Fragment>
            <Grid item xs={12}>
                <Typography component="h2" variant="h6" color="primary" gutterBottom>
                    {MyMess.merchant.secondAuth}
                </Typography>
            </Grid>
            <Grid item xs={12}>         
                <FormControlLabel
                control={
                    <Field component={Switch} type="checkbox" name="enableSecondAuth" />
                }
                label="Enabled"
                />
            </Grid>
            <Grid container>
                <Grid item xs={3}>
                    <Field            
                    name="countryCode"                                
                    render={(props) => 
                        <TextField     
                        label={MyMess.merchant.country}
                        fullWidth {...props}/>}          
                    />  
                </Grid>                
                <Grid item xs={3}>
                    <Field            
                    name="areaCode"                                
                    render={(props) => 
                        <TextField   
                        label={MyMess.merchant.areaCode}
                        fullWidth {...props}/>}          
                    /> 
                </Grid>                
                <Grid item xs={6}>
                    <Field            
                        name="tel"                                
                        render={(props) => 
                            <TextField   
                            label={MyMess.merchant.mobile}
                            fullWidth {...props}/>}          
                        /> 
                </Grid>   
            </Grid>   
        </React.Fragment>  )
}

const billingInfoForm = (editorState) => {
    return(
        <React.Fragment>
            <Grid item xs={12}>
                <Typography component="h2" variant="h6" color="primary" gutterBottom>
                    {MyMess.merchant.billingInfo}Billing Info.
                </Typography>
            </Grid>
            <Grid item xs={12}>                
                <Field            
                name="compName"                                
                render={(props) => 
                    <TextField 
                    label={MyMess.merchant.companyName}
                    fullWidth {...props}/>}          
                />                
            </Grid>       

            <Grid item xs={12}>                
                <Field            
                name="addr"                                
                render={(props) => 
                    <TextField   
                    label={MyMess.merchant.companyAddr+' ' + MyMess.merchant.addr1}
                    fullWidth {...props}/>}          
                />                
            </Grid>   
            <Grid item xs={12}>                
                <Field            
                name="addr2"                                
                render={(props) => 
                    <TextField  
                    label={MyMess.merchant.companyAddr +' ' + MyMess.merchant.addr2}
                    fullWidth {...props}/>}          
                />                
            </Grid>   
            <Grid item xs={12}>                
                <Field            
                name="zipCodeStr"                                
                render={(props) => 
                    <TextField  
                    label={MyMess.merchant.zipCode}
                    fullWidth {...props}/>}          
                />                
            </Grid> 
            <Grid item xs={12}>                
                <Field            
                name="city"                                
                render={(props) => 
                    <TextField    
                    label={MyMess.merchant.city}
                    fullWidth {...props}/>}          
                />                
            </Grid>              
            <Grid item xs={12}>                
                <Field            
                name="province"                                
                render={(props) => 
                    <TextField   
                    label={MyMess.merchant.province}
                    fullWidth {...props}/>}          
                />                
            </Grid> 
            <Grid item xs={12}>                
                <Field            
                name="country"                                
                render={(props) => 
                    <TextField  
                    label={MyMess.merchant.country}
                    fullWidth {...props}/>}          
                />                
            </Grid>
            <Grid container>
                <Grid item xs={3}>
                    <Field            
                    name="compCountryCode"                                
                    render={(props) => 
                        <TextField    
                        label={MyMess.merchant.country}
                        fullWidth {...props}/>}          
                    />  
                </Grid>                
                <Grid item xs={3}>
                    <Field            
                    name="compAreaCode"                                
                    render={(props) => 
                        <TextField  
                        label={MyMess.merchant.areaCode}
                        fullWidth {...props}/>}          
                    /> 
                </Grid>                
                <Grid item xs={6}>
                    <Field            
                        name="compTel"                                
                        render={(props) => 
                            <TextField    
                            label={MyMess.merchant.tel}
                            fullWidth {...props}/>}          
                        /> 
                </Grid>   
            </Grid>            
        </React.Fragment>  )
}

export default function MerchantEditForm() {
    const classes = useStyles();
    const validateHandler = (values) => {
        const errors = {};
        let reqFields = ['email','progCode'];
        if(editorState.mode == 'create'){
            reqFields.push('password');
            reqFields.push('repw');
            
            if(values.password != values.repw){
                errors.repw = MyMess.general.errors.notMatchPassword;
            }     
        }
         checkRequiredHandler(reqFields,values,errors);
         

         if (values.email && !isEmail(values.email)) {
            errors.email = MyMess.general.errors.email
        }

        if(values.email && values.email.length > 100){
            errors.email = MyMess.formatString(MyMess.general.errors.maxLength, 100)
        }

        if(values.password && values.password.length > 40){
            errors.password = MyMess.formatString(MyMess.general.errors.maxLength, 40)
        }

        if(values.code && values.code.length > 40){
            errors.code = MyMess.formatString(MyMess.general.errors.maxLength, 40) 
        }

        if(values.desc && values.desc.length > 200){
            errors.desc = MyMess.formatString(MyMess.general.errors.maxLength, 200)
        }
         

        
        return errors;
    }

    const dispatch = useDispatch();

    const [editorState, setEditorState] = useState({
        mode:'edit',
        pending: false                  
    })

    let { path } = useRouteMatch();
    let param = useParams();


    useEffect(() => {        
        if(path.indexOf('merchant/create') >= 0){
            setEditorState({
                ...editorState,
                mode: 'create'
            })
          dispatch(clearMerchantEdit());    
        }else{            
            setEditorState({
                ...editorState,
                mode: 'edit'
            })           

            if(param.code){
                asyncReadMerchant(param.code);
            }
        }
        return () => {
            
        }
    }, [])


    const merchantData = useSelector(store=> 
        store.merchantEdit
    )  

    const updateStoreHandler = (data) => {        
       dispatch(updateMerchantEdit(data));    
    }

    const submitHandler =() => {   
        let error  = validateHandler(merchantData);        
        if(Object.keys(error).length === 0 && error.constructor === Object){
            startLoadingBar();
            dispatch(asyncSaveMerchantEdit(asaveCallback,editorState.mode))
        }else{
            GlobalSnackBarUtil.open({
                message: MyMess.curd.saveFail,
                severity: 'error'
            })
        }
        
    }

    const startLoadingBar = () => {
        setEditorState({
            ...editorState,
            pending: true
        })
    }

    const stopLoadingBar = () => {
        setEditorState({
            ...editorState,
            pending: false
        })
    }

    const asaveCallback = (res) => {  
        stopLoadingBar();
        if(res && res.pass){
            GlobalSnackBarUtil.open({
                message:MyMess.curd.saveSuccess                
            })

            if(res.info){
                let newCode = res.info.email;
                history.push('/');
                history.push('/main/merchant/edit/' + newCode);
            }
        }
    }

    const asyncReadMerchant = (code) => {
        console.log('calling async read: ' + code);
        startLoadingBar();        
        dispatch(readMerchantEdit(code,readMerchantCallback));
        
    }

    const readMerchantCallback = () => {
        stopLoadingBar();
    }


    let formAPI = {

    }

    const initFormAPI = (formProps) => {
      formAPI.resetForm = formProps.resetForm;
      formAPI.setErrors = formProps.setErrors;
      return true;
    }

    useEffect(() => {
        if(formAPI.resetForm){
            formAPI.resetForm();           
        }       
    }, [merchantData.formUuid])

    
    return (
        
             <Formik
                initialValues={merchantData}        
                validate={validateHandler}  
                //enableReinitialize={true}
                >
             {(formProps) => (                
                 <Container component="main" maxWidth="xs">
                 {editorState.pending  && <LinearProgress />}
                    <Form className={classes.form}>
                        {initFormAPI(formProps)}
                        <Grid container spacing={2}>                        
                            {basicInfoForm(editorState)}
                            {1==2 && secondAuthForm(editorState)}
                            {billingInfoForm(editorState)}

                            <Button                                
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={submitHandler}
                                type="submit">
                                {MyMess.curd.save}
                            </Button> 

                             <Button                                
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={() => { history.push('/main/merchant')}}                                
                            >
                                {MyMess.back}
                            </Button> 
                        </Grid>
                        <FormikPersistStore name="merchantEditForm" handler={updateStoreHandler}></FormikPersistStore>
                    </Form>
                 </Container>
            )}
        </Formik>
        
    )
}
